
import angular from 'angular';

import { CommonsSessionStorageService, IbCTokenUtilsService } from 'ib-web-commons/dist/utils';
import { IbGlobickService } from '../../../services/services/services/ib-globick/ib-globick.service';

const componentOptions = {
    bindings: {
        modules: '=',
        index: '=',
        last: '='
    },
    controllerAs: 'ibGlobickTransfersBoxCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-globick-transfers-box-view.html';
    }]
};


const componentInfo = {
    module: 'ib-globick-transfers-box-module',
    selector: 'ibGlobickTransfersBox',
    inject: ['$scope', 'CommonsSessionStorageService', 'IbCTokenUtilsService', 'IbGlobickService'],
    required: ['']
};

export class ibGlobickTransfersBox implements ng.IController {

    public confirmed: boolean;

    constructor (
        private $scope: angular.IScope,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private IbCTokenUtilsService:IbCTokenUtilsService,
        private IbGlobickService: IbGlobickService
    ) {
        const headerModel: any | null = this.CommonsSessionStorageService.get('headerModel');
        if (headerModel?.headerModel?.shoppingBasket?.globickTransfers?.hasTransfersGlobick) {
            this.confirmed = true;
        } else {
            this.confirmed = false;
        }
        this.$scope.$on('setConfirmed', this.setConfirmed);
        this.$scope.$on('setDisconfirmed', this.setDisconfirmed);
    }

    /**
     * Emit event to parent for open modal of transfers
    */
    openModal = (): void => {
        if (this.confirmed) {
            this.$scope.$emit('openTransfersModifyModal');
        }else {
            this.$scope.$emit('openTransfersModal');
        }
        this.IbGlobickService.registerClickGlobickProduct('TRANS');
    };

    /*
    *
    */
    setConfirmed = () => {
        this.confirmed = true;
    };

    /*
    *
    */
    setDisconfirmed = () => {
        this.confirmed = false;
    };



}

try {
    const mod = angular.module(componentInfo.module);
    let moduleOrNname: string;
    ibGlobickTransfersBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGlobickTransfersBox })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibGlobickTransfersBox.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibGlobickTransfersBox})
    );
}